<template>
  <div id="content">
    <link rel="stylesheet" href="/themes/ito/css/daily-challenge.css?v=5">

    <div class="container">

      <div id="page-header-fixed">
        <div class="container">
          <div id="page-header">
            <ul class="breadcrumb">
              <li class="icon">
                <a @click="getSoundClick(); $router.go(-1)">
                  <img src="/themes/ito/images/back-to.svg" alt="">
                </a>
              </li>
              <li>
                <div class="buttons">
                  <div class="btn-group">
                    <button type="button" class="btn btn-default active" style="position: relative">
                      {{ $t('daily_challenge') }}
                      <div class="noti-alert" v-if="user_info.dailychallenge_noti != 0"></div>
                    </button>
                    <router-link :to="{ path: '/daily-bonus' }" @click.native="getSoundClick">
                      <button type="button" class="btn btn-default" style="position: relative">
                        {{ $t('daily_bonus') }}
                        <div class="noti-alert" v-if="user_info.first_login == 1"></div>
                      </button>
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card card-daily-challenge">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('daily_challenge') }}</span>
          </h5>

          <div class="card-content">
            <div id="daily-challenge">
              <div class="description">
                <div class="col-1">
                  {{ $t('daily_challenge_1') }}
                </div>
                <div class="col-2">
                  <button class="btn btn-ito-1">
                    <b>{{ $t('key_collected') }}:</b> {{ key_collect }} <i class="ito-icon-lock"></i> <br />
                    <b>{{ $t('reset_in') }}</b> {{ time_remain_txt }}
                  </button>
                </div>
              </div>
              <div class="challenges">
                <div class="challenge-list">
                  <template v-for="(challenge, index) in challenges">
                    <daily-challenge-item :challenge="challenge" @updateNewChallenge="updateNewChallenge" />
                  </template>
                </div>

                <div class="swiper-container" id="scroll-tags">
                  <ul class="swiper-wrapper">
                    <div class="swiper-slide" style="display: flex">
                      <div>
                        <div class="collection-list">
                          <template v-for="(mission, index) in missions">
                            <daily-challenge-mission-item :mission="mission" @updateNewMission="updateNewMission"
                              @updateNewChallenge="updateNewChallenge" />
                          </template>
                        </div>
                      </div>
                    </div>
                  </ul>
                  <div class="swiper-scrollbar"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <get-reward-lock-modal :reward="mission_collect" />
      <get-reward-modal :reward="gem_collect" />

    </div>

  </div>
</template>

<script>
import { getDailyChallenge } from '../../models/reward'
import { showDialog } from '../../utils/dialog'
import { mapGetters } from 'vuex'
import { pushQueries, soundClick, convertSecondToText, soundGetReward, soundClaimKey } from "../../utils/utils";
import axios from "axios";
import { getInboxs } from "../../models/inbox";
import DailyChallengeItem from "./DailyChallengeItem";
import DailyChallengeMissionItem from "./DailyChallengeMissionItem";
import GetRewardLockModal from "../modal/GetRewardLockModal";
import GetRewardModal from '../modal/GetRewardModal.vue';


export default {

  name: "DailyChallenge",
  components: { DailyChallengeMissionItem, DailyChallengeItem, GetRewardLockModal, GetRewardModal },
  title: 'Daily challenge',

  data() {
    return {
      challenges: [],
      missions: [],
      key_collect: 0,
      mission_collect: 0,
      gem_collect: 0,
      time_remain: 0,
      time_remain_txt: '00:00:00',
      isLoading: true
    };
  },

  created() {
    this.fetch();
  },

  watch: {
    time_remain: {
      handler(value) {

        if (value > 0) {
          setTimeout(() => {
            this.time_remain--;

            this.time_remain_txt = convertSecondToText(this.time_remain) || '';
          }, 1000);
        }

      },
      immediate: true // This ensures the watcher is triggered upon creation
    }

  },

  computed: {
    ...mapGetters([
      'user_info'
    ], () => {
      if (this.user_info) {
        return this.user_info
      }

      return this.user
    })
  },

  methods: {
    fetch() {
      const that = this;

      //that.user_info.dailychallenge_noti = 1;

      axios.all([
        getDailyChallenge(),
      ]).then(axios.spread((response) => {
        that.isLoading = false;

        if (response.data.code != 0) {
          return;
        }

        that.challenges = response.data.results.challenge || [];
        that.missions = response.data.results.mission || [];
        that.key_collect = response.data.results.key_collect || 0;
        that.time_remain = response.data.results.time_remain || 0;

        this.$nextTick(function () {
          that.initSwiper();
        });

      }));
    },

    getSoundClick() {
      soundClick();
    },

    updateNewChallenge(challenges, key_collect, gem_reward) {
      this.challenges = challenges;
      this.key_collect = key_collect;
      if (gem_reward > 0) {
        this.claimReward(gem_reward);
      }
    },

    updateNewMission(new_key_collect, new_mission_id, new_mission_status, new_mission_collect) {
      //this.missions = new_mission;
      this.key_collect = new_key_collect;
      this.missions.forEach(element => {
        if (element.id == new_mission_id) {
          element.status = new_mission_status;
          this.mission_collect = new_mission_collect;
        }
      });
    },

    claimReward(reward) {
      this.gem_collect = reward;
      this.getSoundClaimKey();
      $('#getRewardedModal').modal('show');
    },

    getSoundClaimKey() {
      soundClaimKey();
    },

    initSwiper() {
      return new Swiper(".swiper-container", {
        slidesPerView: "auto",
        freeMode: true,
        slideToClickedSlide: true,
        spaceBetween: 0,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
        mousewheel: true
      });
    }
  }
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: auto;
  padding: 30px !important;
  /*space for the scrollbar*/
}

ul.swiper-wrapper {
  padding: 0;
}

.swiper-slide {
  width: auto !important;
  ;
}
</style>
